import { useLang } from "../i18n/LanguageContext";
import { BRAND } from "../config/brand";
import { LogoSlot } from "./LogoSlot";
import { Reveal, SectionLabel } from "./Reveal";

export const Collaboration = () => {
  const { t } = useLang();
  return (
    <section id="collaboration" data-testid="collaboration-section" className="scroll-mt-24">
      <Reveal>
        <SectionLabel index="01" testId="collaboration-title">{t.collab.title}</SectionLabel>
      </Reveal>
      <Reveal delay={0.1} className="relative mt-8 grid grid-cols-2 gap-3 sm:gap-4">
        {BRAND.partners.map((p) => (
          <div
            key={p.id}
            data-testid={`partner-card-${p.id}`}
            className="group flex aspect-[4/5] flex-col items-center justify-center gap-5 rounded-[28px] border border-white/[0.07] bg-surface/70 p-5 backdrop-blur-xl transition-colors duration-500 hover:border-gold/30"
          >
            <LogoSlot
              src={p.logo}
              alt={p.name}
              label={t.collab.logoSoon}
              className={`h-28 w-28 transition-transform duration-700 group-hover:scale-105 sm:h-36 sm:w-36 ${p.fade ? "partner-fade rounded-2xl object-cover" : ""}`}
              testId={`partner-logo-${p.id}`}
            />
            <span className="font-display text-sm font-semibold text-zinc-200" data-testid={`partner-name-${p.id}`}>{p.name}</span>
          </div>
        ))}
        <span className="absolute left-1/2 top-1/2 flex h-10 w-10 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-gold/40 bg-ink font-serif text-xl italic text-gold">
          ×
        </span>
      </Reveal>
      <Reveal delay={0.15} className="mt-10">
        <div data-testid="collaboration-description">
          <p className="text-base leading-relaxed text-zinc-300">{t.collab.lead}</p>
          <p className="mt-5 font-serif text-3xl italic leading-[1.1] text-zinc-50 sm:text-4xl">
            {t.collab.mission[0]} <span className="text-gold">{t.collab.mission[1]}</span>
          </p>
          <p className="mt-4 text-base leading-relaxed text-zinc-300">{t.collab.desc}</p>
          <ul className="mt-6 flex flex-wrap gap-2">
            {t.collab.pillars.map((pillar, i) => (
              <li key={pillar} data-testid={`collab-pillar-${i}`} className="rounded-full border border-gold/30 bg-gold/10 px-4 py-2 font-mono text-[12px] uppercase tracking-[0.15em] text-gold">
                {pillar}
              </li>
            ))}
          </ul>
        </div>
      </Reveal>
    </section>
  );
};
